var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 512,
    height: 512,
    viewBox: "0 0 512 512",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 496H976V16H16V496Z",
    fill: "#E74C3C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16 496V16L391.541 16.0032L16 496Z",
    fill: "#FFD664"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16 496V16L224.327 16.0032L16 496Z",
    fill: "#2980B9"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16 496.001H976L966.708 16.0039L16 496.001Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M16 495.999H976L977.131 251.822L16 495.999Z",
    fill: "#479951"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSc);
export default __webpack_public_path__ + "static/media/SC.b0956611c7025c6a46c2d86c73bf7dce.svg";
export { ForwardRef as ReactComponent };